import { useState } from "react";
import { submitPacket } from "@/lib/api";
import { track, getUTM } from "@/lib/analytics";
import { Check } from "lucide-react";

// Rendered inside the Light Executive System (.exec-scope) pages.
export function OperatorPacket({ title, body }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim()) {
      setError("Enter your email.");
      return;
    }
    setStatus("submitting");
    try {
      await submitPacket({ email, utm: getUTM() });
      track("email_capture", { source: "operator_packet" });
      setStatus("success");
    } catch (err) {
      setStatus("idle");
      const detail = err?.response?.data?.detail;
      setError(detail || "Something went wrong. Please try again.");
    }
  };

  return (
    <div
      data-testid="operator-packet"
      className="exec-card p-8 sm:p-10"
    >
      <p className="exec-eyebrow">Resources</p>
      <h3 className="font-light text-[clamp(24px,3vw,34px)] leading-[1.15] mt-4">{title}</h3>
      <p className="exec-serif text-[17px] leading-[1.55] text-[color:var(--lead-ink)] mt-4 max-w-lg">
        {body}
      </p>

      {status === "success" ? (
        <div
          data-testid="operator-packet-success-message"
          className="flex items-center gap-3 mt-7"
        >
          <span className="w-8 h-8 rounded-full border border-[color:var(--copper)] flex items-center justify-center shrink-0">
            <Check size={16} className="text-[color:var(--copper-deep)]" />
          </span>
          <p className="exec-serif text-[17px] text-[color:var(--lead-ink)]">
            You are on the list. The next Operating Room lands in your inbox.
          </p>
        </div>
      ) : (
        <form
          data-testid="operator-packet-form"
          onSubmit={handleSubmit}
          className="mt-7 flex flex-col sm:flex-row sm:items-end gap-4 max-w-lg"
        >
          <input
            data-testid="operator-packet-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            aria-label="Email address"
            className="exec-underline flex-1"
          />
          <button
            type="submit"
            data-testid="operator-packet-submit-button"
            disabled={status === "submitting"}
            className="exec-btn exec-btn-primary whitespace-nowrap"
          >
            {status === "submitting" ? "\u2026" : "Send it"}
          </button>
        </form>
      )}
      {error && (
        <p
          data-testid="operator-packet-error"
          className="exec-serif text-[16px] text-[color:var(--ink)] border-l-2 border-[color:var(--copper)] pl-3 mt-4"
        >
          {error}
        </p>
      )}
    </div>
  );
}
